import userManagementReducer from './reducers';

export { default as userManagementActions } from './actions';
export { default as userManagementOperations } from './operations';
//export { default as dashboardShapes } from './shapes';

export default userManagementReducer;
